<template>
  <div class="mobilePublicNavigation">
    <div class="logo">
      <img :src="logoUrl" alt="LUNA AI" @click="scrollTop" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      logoUrl: require('@/assets/pc/LUNA-AI-logo.png')
    }
  },
  methods: {
    scrollTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped lang="less">
.mobilePublicNavigation {
  background-color: #fff;
  position: fixed;
  width: 100%;
  height: 1.28rem;
  padding: 0.27rem 0.43rem;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 9999;
  .logo {
    cursor: pointer;
    img {
      height: 0.43rem;
    }
  }
}
</style>
